import React from 'react'
import Layout from '../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const MooneyViscometer = () => {

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000
    };

    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FrubberPolymerIndustries%2F8.png?alt=media&token=03e7f89c-d3ca-4f11-b579-850d3d938630',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FrubberPolymerIndustries%2F8.png?alt=media&token=03e7f89c-d3ca-4f11-b579-850d3d938630'
    ];


    return (
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/rubber-polymer-industries">Rubber & Polymer Industries</a></li>
                </ul>
            </div>
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Mooney Viscometer </h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Mooney Viscometer </h3>
                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                    The Vluchem’s MV -10, Mooney Viscometer measure the latest measurement technology
                                    for the traditional Mooney viscosity, Mooney scorch, and stress relaxation measurement
                                    in the rubber industry. Test chamber in compliance with international standards. It can be
                                    Set to the desired temperatures to test and automatic control system regulates and
                                    maintains the set point temperatures.
                                    Standards the instrument complies with ASTM D 1646 ISO 289
                                    <br /> <br />
                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Mooney Viscometer"
                                        style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>
                    </div>
                </div>
            </section>
            <br />
        </Layout>
    )
}

export default MooneyViscometer